export const FETCH_EASYPOST_TRACKING_SUCCESS = 'FETCH_EASYPOST_TRACKING_SUCCESS';
export const FETCH_EASYPOST_TRACKING_REQUEST = 'FETCH_EASYPOST_TRACKING_REQUEST';
export const FETCH_EASYPOST_TRACKING_FAILURE = 'FETCH_EASYPOST_TRACKING_FAILURE';
export const FETCH_EASYPOST_TRACKING_REST = 'FETCH_EASYPOST_TRACKING_REST';
export const fetchEasyPostTrackingSuccess = (payload) => ({
    type: FETCH_EASYPOST_TRACKING_SUCCESS,
    payload,
});
export const fetchEasyPostTrackingRequest = (payload) => ({
    type: FETCH_EASYPOST_TRACKING_REQUEST,
    payload,
});
export const fetchEasyPostTrackingFailure = (payload) => ({
    type: FETCH_EASYPOST_TRACKING_FAILURE,
    payload,
});
export const fetchEasyPostTrackingRest = () => ({
    type: FETCH_EASYPOST_TRACKING_REST,
});
